<template>
  <div class="article banxin content" v-if="obj">
    <div class="subtit">
      <h2>{{ obj.title }}</h2>
      <div class="botBox">
        <div class="time">
          时间：{{ obj.update_time | formateTime }}
        </div>
        <div class="share" @click="handleShare">
          <div class="icon out"></div>
          <div class="wechat">分享到微信</div>
        </div>
      </div>
    </div>
    <div class="cont" v-html="obj.content">

    </div>
    <div class="qrcode-mask" @click="handleClose" v-show="showQr">
      <div class="qrcode">
        <h5>分享到微信</h5>
        <div class="qrbox">
          <div id="qrcode"></div>
        </div>
        <p>用微信“扫一扫”，点击右上角分享按钮，即可将网页分享给您的微信好友或朋友圈。</p>
      </div>
      <div class="close"></div>
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcodejs2'
export default {
  data() {
    return {
      obj: null,
      qrcode: null,
      showQr: false,
      value: 'http://www.baidu.com',
      size: 300
    }
  },
  methods: {
    handleShare() {
      this.showQr = true
      var url = location.href
      if (this.qrcode) {
        this.qrcode.clear()
        this.qrcode.makeCode(url);
      } else {
        this.qrcode = new QRCode("qrcode", {
          text: url,
          width: 200,
          height: 200,
          colorDark: "#000000",
          colorLight: "#ffffff",
          correctLevel: QRCode.CorrectLevel.H
        });
      }
    },
    handleClose(e) {
      var ele = e.target
      if (ele.getAttribute('class') === 'qrcode-mask') {
        this.showQr = false
      }
    }
  },
  mounted() {
    const id = this.$route.params.id
    this.$store.dispatch('get_article_desc', { id })
      .then(res => {
        this.obj = res
      })
    var oldURL = document.referrer;
    console.log(oldURL);
  }
}
</script>
<style lang="less" scoped>
.article {
  padding-top: 1rem;

  .subtit {
    border-bottom: 1px solid #eee;
    margin-bottom: 2rem;

    h2 {
      font-size: 1rem;
    }

    .botBox {
      color: rgba(102, 102, 102, 1);
      font-size: 0.7rem;
      display: flex;
      justify-content: space-between;
      padding: 0.9rem 0;

      .share {
        cursor: pointer;

        .wechat {
          position: relative;

          &::before {
            content: "";
            width: 0.7rem;
            height: 0.7rem;
            background: url('../assets/imgs/NewsAndEvents/wechat.png') no-repeat center/contain;
            position: absolute;
            top: 50%;
            left: -0.2rem;
            transform: translate(-100%, -50%);
          }

          &::after {
            content: "";
            width: 0.8rem;
            height: 0.8rem;
            background: url('../assets/imgs/NewsAndEvents/share.png') no-repeat center/contain;
            position: absolute;
            top: 50%;
            left: -1.4rem;
            transform: translate(-100%, -50%);
          }
        }
      }
    }
  }

  .cont {
    font-size: .8rem;
    line-height: 1.4rem;
    color: #666;
  }

  .qrcode-mask {
    background: rgba(0, 0, 0, .2);
    position: fixed;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    z-index: 999999;

    .qrcode {
      width: 300px;
      margin: 50px auto;
      border: 1px solid #ddd;
      padding: 10px;
      background: #fff;

      h5 {
        font-size: 16px;
      }

      .qrbox {
        width: 200px;
        margin: 20px auto;
      }

      p {
        font-size: 14px;
        margin-bottom: 0;
      }
    }
  }
}
</style>


